import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';

const useStyles = makeStyles({
  root: {
    border: 'none',
    borderTop: 1,
    borderColor: 'mainDivider',
    width: '100%',
    margin: 0,
  },
});

const JWHr: FC<any> = ({ ...props }) => {
  const classes = useStyles();
  // HOOKS END

  return <hr className={classes.root} {...props} />;
};

export default JWHr;
